import { render, staticRenderFns } from "./AppSidebarItem.vue?vue&type=template&id=2899860a&"
import script from "./AppSidebarItem.vue?vue&type=script&lang=js&"
export * from "./AppSidebarItem.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarItem.vue?vue&type=style&index=0&id=2899860a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports